import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { resetState } from '../actions';
import { NotificationType, StateStatus } from '../core';
import { UPLOAD_FILE } from '../new';
import { CREATE_SECTION, DELETE_SECTION, DUPLICATE_SECTION, getSections, SECTION_ADD_FILE, SECTION_REMOVE_FILE, SECTION_REORDER, SECTIONS, UPDATE_SECTION } from '../new/section';
import { NOTIFICATION } from '../types';
const useSections = _ref => {
  let {
    productId,
    sectionId,
    silent
  } = _ref;
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const {
    data,
    status,
    version,
    entity,
    request
  } = useSelector(state => state.sections.all);
  const {
    create,
    update,
    remove,
    addFile,
    removeFile,
    reorder,
    duplicate
  } = useSelector(state => state.sections);
  const upload = useSelector(state => state.files.upload);
  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED || status === StateStatus.LOADED && (request === null || request === void 0 ? void 0 : request.productId) !== productId) {
      dispatch(getSections(productId, silent));
    }
    if (create.version || update.version || remove.version || addFile.version || removeFile.version || reorder.version || upload.version || duplicate.version) {
      dispatch(resetState(SECTIONS));
      if (create.version || update.version) {
        dispatch(resetState(CREATE_SECTION));
        dispatch(resetState(UPDATE_SECTION));
      }
      if (upload.version) {
        dispatch(resetState(UPLOAD_FILE));
      }
      remove.version && dispatch(resetState(DELETE_SECTION));
      addFile.version && dispatch(resetState(SECTION_ADD_FILE));
      removeFile.version && dispatch(resetState(SECTION_REMOVE_FILE));
      reorder.version && dispatch(resetState(SECTION_REORDER));
      duplicate.version && dispatch(resetState(DUPLICATE_SECTION));
    }
    if (!remove.status && remove.errors) {
      dispatch({
        type: NOTIFICATION,
        payload: {
          message: t("VALIDATIONS.".concat(remove.errors[0].message)),
          variant: NotificationType.Error
        }
      });
    }
  }, [addFile.version, create.version, dispatch, duplicate.version, productId, remove.errors, remove.status, remove.version, removeFile.version, reorder.version, request, silent, status, t, update.version, upload.version]);
  if (sectionId && data) {
    const section = data.find(x => x.id === sectionId);
    return {
      section,
      status,
      version,
      entity
    };
  }
  if (!productId) {
    return {
      data: null,
      status: StateStatus.NOT_INITIALIZED
    };
  }
  return {
    data: data || [],
    status,
    version,
    entity
  };
};
export default useSections;